import request from '@/utils/request'

// 获取物料列表
export function getList(params) {
  return request.get('/material/list', { params })
}

// 创建物料信息
export function createOne(data) {
  return request.post('/material/create', data)
}

// 更新物料信息
export function updateOne(data) {
  return request.post('/material/update', data)
}

// 删除物料信息
export function deleteOne(data) {
  const url = '/material/delete/' + data.id
  return request.get(url)
}

// 获取待检测列表
export function getMaterialCheckList(params) {
  return request.get('/dualCheck/list', { params })
}

// 粉料检测申请
export function createMaterialCheckOne(data) {
  return request.post('/dualCheck/create', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 粉料检测审核
export function updateMaterialCheckOne(data) {
  return request.post('/dualCheck/check', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}